import { render, staticRenderFns } from "./EmployeeWarningTooltip.vue?vue&type=template&id=f0c2d57a&"
import script from "./EmployeeWarningTooltip.vue?vue&type=script&lang=js&"
export * from "./EmployeeWarningTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports